'use strict';

export default {
  getSoParams(state) {
    return state.soParams;
  },
  getCompanyInfo(state) {
    return state.soCompanyInfo;
  },
  getEmailList(state) {
    return state.soEmailList;
  },
  getHistory(state) {
    return state.soHistory;
  },
  getHistoryList(state) {
    return state.soHistoryList;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/so/getters.js